export default __webpack_public_path__ + "static/media/rocket.feaa5d7c.png";